import * as Styled from './about-edit-view.styles';

export const AboutEditViewSkeleton: React.FC = () => {
  return (
    <>
      <Styled.SkeletonHeadline size="medium" alignment="left" amountRows={1} />
      <Styled.SkeletonBodyCopy amountRows={2} />
      <Styled.SkeletonFormField size="medium" />
    </>
  );
};
